import useEntitlements from "./useEntitlements";

const LABELS = {
  pay_as_you_go: { type: "payg", label: "Pay as you go" },
  growth: { type: "growth", label: "Growth" },
  enterprise: { type: "enterprise", label: "Enterprise" },
};

const usePlan = () => {
  const { planCode } = useEntitlements();
  const badge = LABELS[planCode] || LABELS.pay_as_you_go;
  return { planType: badge.type, planBadge: badge };
};

export default usePlan;
